// @flow
import get from 'lodash/get';
import type { NewsletterNotifications, SearchNotification, SubscriptionResponse } from '../types';
import { FREQUENCY_DAILY } from '../constants';
import getQueryMapperByVerticalId from '../../shared/SearchNotifications/adapters/subscriptionQueryMapper/getQueryMapperByVerticalId';

function mapNewsletterNotifications(response: Object): NewsletterNotifications {
  const newsletterNotifications = response.data.attributes.newsletters_configuration;

  return {
    trovitNewsletters: {
      active: newsletterNotifications.trovit_newsletter_active,
      changed: false,
    },
    partnersNewsletters: {
      active: newsletterNotifications.partners_newsletter_active,
      changed: false,
    },
  };
}

function mapSearchNotifications(
  verticalId: number,
  response: Object
): Array<SearchNotification<*>> {
  const apiSearchNotifications = get(response, 'included', []);

  return apiSearchNotifications.map(apiSearchNotification => {
    const frequency = get(
      apiSearchNotification,
      'attributes.notification.frequency',
      FREQUENCY_DAILY
    );

    const mapQuery = getQueryMapperByVerticalId(verticalId);

    return {
      id: apiSearchNotification.id,
      type: apiSearchNotification.type,
      createdAt: get(apiSearchNotification, 'attributes.dates.creation', ''),
      updatedAt: get(apiSearchNotification, 'attributes.dates.updated', ''),
      frequency,
      active: get(apiSearchNotification, 'attributes.notification.active', false),
      suggested: get(apiSearchNotification, 'attributes.notification.suggested', false),
      query: mapQuery(apiSearchNotification),
      changed: false,
    };
  });
}

export default function map(verticalId: number, response: Object): SubscriptionResponse<*> {
  return {
    newsletterNotifications: mapNewsletterNotifications(response),
    searchNotifications: mapSearchNotifications(verticalId, response),
  };
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/adapters/subscriptionResponse.js